import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiOverlayMask, EuiText } from '@elastic/eui';
import React, { useMemo } from 'react';

interface Props{
  onClose(response:any):any;
  isOpen?: boolean;
  action?: string;
  answer?: string;
  className?:string;
}

export const ModalYesNo = (props:Props) =>{

  let {onClose, isOpen, action, answer} = props;

  const getFooter = useMemo(() =>{
      return(
        <EuiModalFooter>
          <EuiFlexGroup justifyContent="spaceBetween">
          <EuiFlexItem>
              <EuiButton onClick={()=>onClose(true)}>Si</EuiButton>
          </EuiFlexItem>
          <EuiFlexItem>
              <EuiButton color="danger" onClick={()=>onClose(false)}>No</EuiButton>
          </EuiFlexItem>
          </EuiFlexGroup>
        </EuiModalFooter>
      )
  },[onClose])

  const getContent = () => {
      return (
        <EuiText textAlign="left"><h3>{answer ? answer : `¿${action? action : 'Eliminar'} los elementos seleccionados?`}</h3></EuiText>
      );
  }

  return isOpen ? (
    <EuiOverlayMask>
      <EuiModal id="modalYesNo" onClose={()=>onClose(false)}  maxWidth={false}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>{"Confirmar acción"}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
          {getContent()}
        </EuiModalBody>
        { getFooter }
      </EuiModal>
    </EuiOverlayMask>
  ) : null
}
export default ModalYesNo;